/* Button Action Types */
export const UPDATE_PLATFORM = "UPDATE_PLATFORM";
export const UPDATE_GOOGLE_PLATFORM = "UPDATE_GOOGLE_PLATFORM";
export const UPDATE_MODE = "UPDATE_MODE";
export const SET_CATEGORY = "SET_CATEGORY";
export const FILTER_POSTS = "FILTER_POSTS";
export const RETURN_POSTS = "RETURN_POSTS";
export const SET_CATEGORY_ARRAY = "SET_CATEGORY_ARRAY";
export const SET_CATEGORIES = "SET_CATEGORIES";
export const FILTER_CATEGORY = "FILTER_CATEGORY";
export const SET_DEFAULT_CATEGORY = "SET_DEFAULT_CATEGORY";

/* Url Types */
export const SET_LINK_V_PARAM = "SET_LINK_V_PARAM";
export const SET_LINK_URL_PARAM = "SET_LINK_URL_PARAM";
export const SET_WEBSITE_EMBEDDING = "SET_WEBSITE_EMBEDDING";
export const SET_MULTIROW = "SET_MULTIROW";
export const SET_CATEGORYID = "SET_CATEGORYID";
export const SET_URL_PARAMS = "SET_URL_PARAMS";

/* API Types */
export const LANDING_START = "LANDING_START";
export const LANDING_SUCCESS = "LANDING_SUCCESS";
export const LANDING_FAILURE = "LANDING_FAILURE";
export const READY_MADE_START = "READY_MADE_START";
export const READY_MADE_SUCCESS = "READY_MADE_SUCCESS";
export const READY_MADE_FAILURE = "READY_MADE_FAILURE";
export const URL_SHORTEN_START = "URL_SHORTEN_START";
export const URL_SHORTEN_SUCCESS = "URL_SHORTEN_SUCCESS";
export const URL_SHORTEN_FAILURE = "URL_SHORTEN_FAILURE";
export const TRACK_SHARE = "TRACK_SHARE";
export const TRACK_SESSION = "TRACK_SESSION";
export const GTAG_POST_SHARE = "GTAG_POST_SHARE";

/* Post Action Types */
export const SET_EDITING = "SET_EDITING";
export const EDIT_POST_TEXT = "EDIT_POST_TEXT";
export const SET_CUSTOM_TEXT = "SET_CUSTOM_TEXT";
